module.exports = __webpack_public_path__ + "200135e8e5aec51916af96b03c1ee8fc.ttf";